import { Component, OnInit } from '@angular/core';
import { PolicyService } from '@app/api/policy.service';
import { ActivatedRoute } from '@angular/router';

import { Router } from '@angular/router';

import { SystemSettingService } from '@app/api/systemsettting.service';
@Component({
  selector: 'meu-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  id: string;
  policy: any = null;

  createAt;
  constructor(
    private policyService: PolicyService,
    private route: ActivatedRoute,
    private system: SystemSettingService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
     
      // this.getPolicyBySlug(this.slug);
    });

    this.getPolicy(this.id);
  }

  getPolicy(id) {
    this.system.apiSystemSettingIdGet(id).subscribe((res) => {
      if (res.success) {
      
        this.policy = res.data.value;
        this.createAt = res.data.created_at;
      }
    });
  }

  // getPolicyBySlug(slug) {
  //   this.policyService.apiPoliciesSlugGet(slug).subscribe(
  //     (res) => {
  //       if (res.success && res.data) {
  //         this.policy = res.data;
  //         this.updateAt = res.data.updated_at;
  //       } else {
  //         this.router.navigate(['/']);
  //       }
  //     },
  //     (error) => {
  //       this.router.navigate(['/']);
  //     }
  //   );
  // }
}
